import React, { FunctionComponent } from 'react'
import classnames from 'classnames'

interface Meta {
  error: string
  submitFailed: boolean
}

export interface Props {
  label: string
  input: any // TODO-TS
  meta: Meta
  gridClass: string
}

const SelectField: FunctionComponent<Props> = ({
  label,
  children,
  input,
  meta,
  gridClass,
  ...rest
}) => {
  const { submitFailed, error } = meta

  return (
    <div
      className={classnames('form__group', {
        [`${gridClass}`]: gridClass,
      })}
    >
      {label && (
        <label className="form__label" htmlFor={input.name}>
          {label}
        </label>
      )}
      <div className="select-wrapper">
        <select
          id={input.name}
          {...input}
          {...rest}
          className={classnames('form__control', 'form__control--select', {
            'form__control--error': submitFailed && error,
          })}
        >
          {children}
        </select>
        {submitFailed && error && (
          <p className="form__help-text text-error">{meta.error}</p>
        )}
      </div>
    </div>
  )
}

export default SelectField
